import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../guards/authenticated.guard';
import { ShareContactInfoPageModule } from '../share-contact-info/share-contact-info.module';
import { NetSheetPageComponent } from './net-sheet.page';
import { ReportPageModule } from './report/report.module';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: NetSheetPageComponent,
    path: ''
  },
  {
    loadChildren: () => ReportPageModule,
    path: 'report'
  },
  {
    loadChildren: () => ShareContactInfoPageModule,
    path: 'share-contact-info'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class NetSheetPageRoutingModule {}
